import { render } from "./WpeImageSelect.vue?vue&type=template&id=64a7a2b8"
import script from "./WpeImageSelect.vue?vue&type=script&lang=js"
export * from "./WpeImageSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeImageSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64a7a2b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64a7a2b8', __exports__)) {
    api.reload('64a7a2b8', __exports__)
  }
  
  module.hot.accept("./WpeImageSelect.vue?vue&type=template&id=64a7a2b8", () => {
    api.rerender('64a7a2b8', render)
  })

}


export default __exports__